import { INTERNAL } from '../components/settings/AccessPolicies/constants';
import { useGroupsQuery } from '../queries';
import { useUserGroup } from './useUserGroup';

export const useHasAccess = () => {
  const userGroupName = useUserGroup();
  const { data: groupsFromQuery } = useGroupsQuery();
  const groups = groupsFromQuery || [];
  const internalGroups = groups.filter((group) => group.scope === INTERNAL);

  return internalGroups.some((group) => group.name === userGroupName);
};
